import { FaArrowLeft } from "react-icons/fa";
import { useBackButtonData } from "./backButtonData";
import "./index.scss";

const BackButton = ({ color = "white" }) => {
  const { handleBack } = useBackButtonData();

  return (
    <button
      onClick={handleBack}
      className="back-button"
      style={{ color }}
      aria-label="Go back"
    >
      <FaArrowLeft size={18} style={{ color }} />
      <span className="back-button__text" style={{ color }}>
        Back
      </span>
    </button>
  );
};

export default BackButton;
